export default "__VITE_ASSET__DmuVM0Jf__"